import BrandListIntegrations from './BrandListIntegrations';

export default BrandListIntegrations;
